<template>
  <v-menu v-model="menu" :close-on-content-click="false" transition="fade-transition" offset-y>

    <template v-slot:activator="{ on }">
      <v-text-field v-model="c_label" v-on="on" class="ma-1" prepend-inner-icon="mdi-calendar" label="Perioadă" outlined readonly hide-details/>
    </template>

    <v-card tile flat>
      <im-date-picker v-model="c_value" mode='range' locale="ro" is-inline style="border-width: 0" :min-date="c_min_date" :columns="2"></im-date-picker>

      <v-divider class="mx-2"/>

      <v-card-actions>
        <v-spacer/>
        <v-btn depressed color="primary" @click="menu=false">
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>



  </v-menu>

</template>

<script>
  export default {

    props: {
      check_in: {
        type: String,
        default: () => null
      },
      check_out: {
        type: String,
        default: () => null
      },
    },

    data: () => ({
      menu: null
    }),

    computed: {

      c_value: {
        get() {
          return {
            start: new Date(this.check_in),
            end: new Date(this.check_out)
          };
        },
        set(val) {
          this.$emit("update:check_in", this.$moment(val.start).format('YYYY-MM-DD'));
          this.$emit("update:check_out", this.$moment(val.end).format('YYYY-MM-DD'));
        }
      },

      c_label: function () {
        return this.$moment(this.c_value.start).format('LL') + ' ➞ ' + this.$moment(this.c_value.end).format('LL')
      },

      c_min_date: function () {
        return new Date();
      }
    }

  }
</script>
